import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SubAdminListLayer from "../../components/SubAdmin/SubAdminListLayer";


const SubAdminListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Sub Admin" />

        {/* UsersListLayer */}
        <SubAdminListLayer />

      </MasterLayout>

    </>
  );
};

export default SubAdminListPage; 
